import type { Meeting } from '../../entities/meeting/meetingTypes';
import { MOCK_GROUP_ID } from './mockSite';

/**
 * Dataset mock per Meeting. Mix di durate (15/30/45/60/90/120 min) e
 * status assortiti (planned/completed/missing/cancelled/replanned)
 * per testare i filtri. meetingDate distribuite su 4 mesi.
 */
const baseAudit = { companyId: 1, groupId: MOCK_GROUP_ID, userId: 1, userName: 'Jader Francia' };
const auditAt = (iso: string) => ({ ...baseAudit, createDate: iso, modifiedDate: iso });

export const mockMeetings: Meeting[] = [
  // --- Aprile 2026 ---
  {
    meetingId: 1,
    meetingDate: '2026-04-15T10:00:00Z',
    duration: 60,
    title: 'Kick-off Fornari Srl',
    description: 'Kick-off progetto integrazione con Fornari Srl. Presentazione team, timeline e milestone Q2.',
    location: 'Sede Fornari, Trento',
    notes: 'Portare le slide con timeline Q2 e la lista delle milestone.',
    status: 'planned',
    ...auditAt('2026-04-09T11:00:00Z'),
  },
  {
    meetingId: 2,
    meetingDate: '2026-04-08T14:30:00Z',
    duration: 90,
    title: 'Review architettura Acme',
    description: 'Review tecnica architettura con CTO Acme. Discussi i vincoli di integrazione con il sistema legacy.',
    location: 'Google Meet',
    status: 'completed',
    ...auditAt('2026-04-08T16:00:00Z'),
  },
  {
    meetingId: 3,
    meetingDate: '2026-04-03T09:30:00Z',
    duration: 30,
    title: 'Stand-up settimanale',
    description: 'Stand-up settimanale interno - status preventivi e pipeline.',
    location: 'Sala riunioni interna',
    status: 'completed',
    ...auditAt('2026-04-03T10:00:00Z'),
  },

  // --- Marzo 2026 ---
  {
    meetingId: 4,
    meetingDate: '2026-03-25T11:00:00Z',
    duration: 60,
    title: 'Demo prodotto Giubra',
    description: 'Demo prodotto a Elena Marchetti (Giubra). Focus sul modulo dashboard e reportistica.',
    location: 'Microsoft Teams',
    status: 'completed',
    ...auditAt('2026-03-18T15:00:00Z'),
  },
  {
    meetingId: 5,
    meetingDate: '2026-03-20T15:00:00Z',
    duration: 45,
    title: 'Follow-up Miksi',
    description: 'Call di follow-up con Roberto Bianchi (Miksi). Cliente ha richiesto rinvio.',
    location: 'Telefono',
    notes: 'Cliente ha richiesto rinvio: ricontattare la prossima settimana.',
    status: 'replanned',
    ...auditAt('2026-03-19T08:00:00Z'),
  },
  {
    meetingId: 6,
    meetingDate: '2026-03-12T09:00:00Z',
    duration: 120,
    title: 'Workshop processi Trentino Sicurezza',
    description: 'Workshop tecnico in sede Trentino Sicurezza. Mappatura processi attuali e gap analysis.',
    location: 'Sede Trentino Sicurezza, Trento',
    status: 'completed',
    ...auditAt('2026-03-11T17:00:00Z'),
  },
  {
    meetingId: 7,
    meetingDate: '2026-03-05T14:00:00Z',
    duration: 30,
    title: 'Allineamento commerciale Q2',
    description: 'Allineamento commerciale interno - strategie Q2.',
    location: 'Sala riunioni interna',
    status: 'missing',
    ...auditAt('2026-03-05T14:30:00Z'),
  },

  // --- Febbraio 2026 ---
  {
    meetingId: 8,
    meetingDate: '2026-02-22T10:30:00Z',
    duration: 60,
    title: 'Kick-off Edilizia Moderna',
    description: 'Riunione di kick-off con Edilizia Moderna. Definito piano implementazione fase 1.',
    location: 'Sede cliente, Rovereto',
    status: 'completed',
    ...auditAt('2026-02-22T12:00:00Z'),
  },
  {
    meetingId: 9,
    meetingDate: '2026-02-12T15:30:00Z',
    duration: 45,
    title: 'Call pilot austriaco AlpiSolar',
    description: 'Call con AlpiSolar (Thomas Huber) sul progetto pilot austriaco.',
    location: 'Google Meet',
    status: 'cancelled',
    ...auditAt('2026-02-10T09:00:00Z'),
  },

  // --- Gennaio 2026 ---
  {
    meetingId: 10,
    meetingDate: '2026-01-30T10:00:00Z',
    duration: 90,
    title: 'Pianificazione roadmap 2026',
    description: 'Pianificazione roadmap 2026 - allineamento direzione + commerciale.',
    location: 'Sala direzione',
    status: 'completed',
    ...auditAt('2026-01-30T12:00:00Z'),
  },
];
